// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__tupGj","Cell":"EmployeeTable_Cell__WdLDN","Paper":"EmployeeTable_Paper__fC+my"};